import { Component, OnInit, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { SpinnerRef } from '../../../common/components/spinner/overlay-ref.service';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { SelectedVehicleState } from '../../../store/selected-vehicle-store/selected-vehicle-state.model';
import { NgIf, NgFor } from '@angular/common';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-digital-key',
    templateUrl: './digital-key.component.html',
    styleUrls: ['./digital-key.component.scss'],
    imports: [NgIf, MatCard, MatCardTitle, MatCardContent, FormsModule, MatFormField, MatInput, MatSelect, NgFor, MatOption, TranslatePipe]
})
export class DigitalKeyComponent implements OnInit, OnDestroy {
  /**
 *@var Declaration of spinner Ref
 **/
  public spinnerRef: SpinnerRef;
  /**
  * Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
   * @property lookUpKey to store the response
   */
  public lookUpKey: object;
  /**
   * @property to store the subscriptions
   */
  private apiSubscription: Subscription;
  /**
  *@arg selectedVehicleObservable to observe selectedVehicle observable
  **/
  @select('selectedVehicle') readonly selectedVehicleObservable: Observable<SelectedVehicleState>;
  /**
 * @property used to store the api subscription
 */
  private selectedVehicleSubscriber: Subscription;
  /**
 * @property used to store the Owner GUID
 */
  public ownerGuid: any;
  /**
 * @property used to store the array of lookup keys with same GUID
 */
  public lookUpKeyWithLimited = [];

  constructor(
    public translate: TranslationService,
    public customerDispatcher: CustomerDispatcher,
    public orch: OrchestrationService,
    public fb: UntypedFormBuilder,
    public spinner: SpinnerService,
    private apiDispatcher: ApiResponseDispatcher,
  ) {
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      if (!!this.spinnerRef) { this.spinnerRef.close(); }
      if (api.apiAction === ApiResponseActions.SET_LOOKUP_KEY) {
        const temp = api.lookupKeys['type'] === 'success' && !!api.lookupKeys['payload'] ?
          this.findlookUpKeySuccess(api.lookupKeys['payload']) : api.lookupKeys['type'] === 'error' ? this.findlookUpKeyError(api.lookupKeys) : null;
      }
    });
    this.selectedVehicleSubscriber = this.selectedVehicleObservable.subscribe({
      next: ({ vehicle }) => {
      if (!!vehicle['capabilities'] && ['DigitalKeyEnhanced', 'DigitalKeyFactory', 'DigitalKeySKB'].some(capability => vehicle['capabilities'].map(({ name }) => name).includes(capability)) && !!vehicle['subscriptions'] && ['PROD_REMKEY1',
      'PROD_REMKEY2',
      'PROD_EREMKEY',
      'PROD_B1_REMKEY1NAV',
      'PROD_B1_REMKEY2NAV',
      'PROD_B1_EREMKEYNAV',
      'PROD_B2_REMKEY1NAVSTRM',
      'PROD_B2_REMKEY2NAVSTRM',
      'PROD_B2_EREMKEYNAVSTRM',
      'PROD_B3_REMKEY1STRM',
      'PROD_B3_REMKEY2STRM',
      'PROD_B3_EREMKEYSTRM',
      'PROD_REMLSKEY',
      'PROD_B1_REMLSKEYNAV',
      'PROD_B2_REMLSKEYNAVSTRM',
      'PROD_B3_REMLSKEYSTRM'].some(product => vehicle['subscriptions'].map(({ productCode }) => productCode).includes(product)) &&
        ['ACTIVE'].some(product => vehicle['subscriptions'].map(({ status }) => status).includes(product))) { this.orch.lookupKey(vehicle['vin']); }
    },
      complete: () => this.selectedVehicleSubscriber.unsubscribe()
    }
    );
  }
  ngOnInit() {
  }
  /**
   * ondestroy method
   */
  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
    if (this.selectedVehicleSubscriber) {
      this.selectedVehicleSubscriber.unsubscribe();
    }
  }
  /**
 * @function findlookUpKeySuccess Action after a successful API response
 * @param response  Response of the API
 **/
  public findlookUpKeySuccess(payload: any): void {
    this.lookUpKey = payload[0];
    payload.forEach(element => {
      if (element.serviceKeyType === 'OWNER') {
        this.ownerGuid = element.guid;
      }
    });
    payload.forEach(value => {
      if (value.serviceKeyType === 'LIMITED' || value.serviceKeyType === 'LUK') {
        const guid = value.guid;
        if (!!guid) {
          this.orch.searchCustomer('subscriptionHistoryCustomer', { guid });
          this.fetchAllEmails(value);
        }

        this.lookUpKeyWithLimited.push(value);
      }
    });
  }

  /**
* @function fetchAllEmails Action after a successful API response
* @param response  Response of the API
 **/

  public fetchAllEmails(value) {
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      if (!!this.spinnerRef) { this.spinnerRef.close(); }
      if (api.apiAction === ApiResponseActions.SET_SUBSCRIPTION_HISTORY_CUSTOMER) {
        if (api.subscriptionHistoryCustomer['state']['type'] === 'success') {
          if (!!!value.email && value.guid === api.subscriptionHistoryCustomer['state'].customer.guid) {
            value['email'] = api.subscriptionHistoryCustomer['state'].customer.emails[0].emailAddress;
          }
        }
      }
    });
  }

  /**
* @function errorCallback Action for error after API response
* @param error  Response of the API
**/
  public findlookUpKeyError(error: object): void {
    this.apiDispatcher.setLookUpkeysResponse({});
  }

  /**
* @function getSharedUsersString To get the shared users string
**/
  public getSharedUsersString(): string {
    return 'Shared Users ' + '(' + this.lookUpKeyWithLimited.length + ')';
  }
}
